// extracted by mini-css-extract-plugin
export default {"publicationsChart":"publications-chart_publicationsChart__Pkx2G"};